import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';

export class ChapterPropertyConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, attribute, current, incoming } = conflict;

		state.initialCourse.chapters.entities[entityId][attribute] = incoming;
		state.chapters.entities[entityId][attribute] = current;
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, attribute, incoming } = conflict;

		state.initialCourse.chapters.entities[entityId][attribute] = incoming;
		state.chapters.entities[entityId][attribute] = incoming;
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, attribute, current, incoming } = conflict;

		state.initialCourse.chapters.entities[entityId][attribute] = incoming;
		state.chapters.entities[entityId][attribute] = `${current} ${incoming}`;
	};
}
